<script setup>
import { computed, toRefs } from 'vue';

import useSpacing from '@/composables/useSpacing';

const props = defineProps(['settings']);
const { settings } = toRefs(props);

const maxWidth = computed(() => {
  const width = settings?.value?.maxWidth;
  return width ? `${width}%` : '100%';
});

const { padding } = useSpacing(settings);
</script>
<template>
  <div
    class="element text-element"
    v-html="settings.content"
  />
</template>

<style lang="scss" scoped>
.text-element {
  max-width: v-bind(maxWidth);
  margin: auto;
  padding: v-bind(padding);

  :deep(ol) {
    list-style-type: decimal;
    padding: revert;
    margin: revert;
  }

  :deep(ul) {
    list-style-type: disc;
    padding: revert;
    margin: revert;
  }
}
</style>
